module.exports = __webpack_public_path__ + "static/media/motherboard-repair.42fcf292.jpg";